import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getSystemsAdmins } from '../../../api/system';

const useSystemAdmins = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  params?: { organization_id?: string }
) => {
  return useQuery({
    queryKey: ['allSystemAdmins'],
    queryFn: () => getSystemsAdmins(params),
    ...options,
  });
};

export default useSystemAdmins;
